import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PASSWORD_VALIDATION_LIST } from 'common/forms/FormValidationHelper';

export const PasswordErrors = ({ password, className }) => (
  <div className={className}>
    <FormattedMessage id="page.user.error.password.title" defaultMessage="Your password needs to:" tagName="strong" />
    <ul className="rules p-0 m-0 mt-2 ml-2 text-secondary">
      {Object.entries(PASSWORD_VALIDATION_LIST).map(([key, regex]) => {
        const isValid = regex.test(password);
        const icon = isValid ? 'check' : 'close';
        return (
          <li
            key={key}
            data-cy={key}
            className={classnames('list-none mb-0', {
              'text-success': isValid,
              'text-danger': !isValid,
            })}
          >
            <i className={`mr-2 fb-icon--${icon}`} />
            <FormattedMessage
              id={`page.user.error.password.${key}`}
              defaultMessage={`respect the validation rule ${key}`}
            />
          </li>
        );
      })}
    </ul>
  </div>
);
